import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { getFeatureFlagOutsideOfReactLifecycleHelper } from '@seek/candidate-feature-flag';

import { selectFeatureFlagOverrides } from 'src/store/selectors';
import type { ChaliceStore } from 'src/store/types';

export const getFeatureFlagWithOverridesHelper = ({
  apolloClient,
  getState,
}: {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  getState: () => ChaliceStore;
}) =>
  getFeatureFlagOutsideOfReactLifecycleHelper({
    apolloClient,
    overridesGetter: () => selectFeatureFlagOverrides(getState()) || {},
  });
